import { render, staticRenderFns } from "./BusinessPlanShared.vue?vue&type=template&id=cd56c1bc&scoped=true"
import script from "./BusinessPlanShared.vue?vue&type=script&lang=js"
export * from "./BusinessPlanShared.vue?vue&type=script&lang=js"
import style0 from "./BusinessPlanShared.vue?vue&type=style&index=0&id=cd56c1bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd56c1bc",
  null
  
)

export default component.exports